import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../../organisms/header/header.component';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from '../../organisms/sidebar/sidebar.component';
import { MobileSidebarComponent } from '../../organisms/mobile-sidebar/mobile-sidebar.component';
import { Store } from '@ngrx/store';
import { selectMainLayoutLoading } from '../../../../core/state/app.state';
import { SpinnerComponent } from '../../atoms/spinner/spinner.component';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, HeaderComponent, CommonModule, SidebarComponent, MobileSidebarComponent, SpinnerComponent],
  templateUrl: './main-layout.component.html',
  styleUrl: './main-layout.component.scss'
})
export class MainLayoutComponent {
  private store = inject(Store);
  isLayoutLoading = this.store.selectSignal(selectMainLayoutLoading);
}
